const escapeHtml = (value: string) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')

const cleanLinkLabel = (value: string) => value.replace(/\+\+/g, '').replace(/~~/g, '').trim()

export const renderMaintenanceInline = (value: string) => {
  const escaped = escapeHtml(value)
  return escaped
    .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, (_match, label: string, href: string) => {
      const text = cleanLinkLabel(label) || href
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`
    })
    .replace(/\+\+(<a\b)/g, '$1')
    .replace(/(<\/a>)\+\+/g, '$1')
    .replace(/\+\+([\s\S]+?)\+\+/g, '<u>$1</u>')
    .replace(/~~([^~]+)~~/g, '<s>$1</s>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/(^|[\s(])\*([^*\n]+)\*/g, '$1<em>$2</em>')
}

export const renderMaintenanceMarkdown = (value: string) => {
  const lines = String(value ?? '')
    .replace(/\r\n/g, '\n')
    .replace(/\][ \t]*\n[ \t]*\(/g, '](')
    .split('\n')
  const html: string[] = []
  let list: 'ul' | 'ol' | null = null
  const closeList = () => {
    if (!list) return
    html.push(`</${list}>`)
    list = null
  }

  lines.forEach((line) => {
    const bullet = line.match(/^\s*[-*]\s+(.*)$/)
    const numbered = line.match(/^\s*\d+\.\s+(.*)$/)
    if (bullet) {
      if (list !== 'ul') {
        closeList()
        html.push('<ul>')
        list = 'ul'
      }
      html.push(`<li>${renderMaintenanceInline(bullet[1])}</li>`)
      return
    }
    if (numbered) {
      if (list !== 'ol') {
        closeList()
        html.push('<ol>')
        list = 'ol'
      }
      html.push(`<li>${renderMaintenanceInline(numbered[1])}</li>`)
      return
    }
    closeList()
    if (line.trim() === '') {
      html.push('<br />')
      return
    }
    html.push(`<p>${renderMaintenanceInline(line)}</p>`)
  })
  closeList()
  return html.join('')
}
